import { render, staticRenderFns } from "./bo-product-matrix-mobile.vue?vue&type=template&id=7266f3a5"
import script from "./bo-product-matrix-mobile.vue?vue&type=script&lang=js"
export * from "./bo-product-matrix-mobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports